import React from 'react';
import '../../styles/stats-card.css';

const StatsCard = ({ title, value, subtitle, icon, trend, alert }) => {
  const getTrendIcon = () => {
    if (trend > 0) return '📈';
    if (trend < 0) return '📉';
    return '➡️';
  };

  const getTrendClass = () => {
    if (trend > 0) return 'positive';
    if (trend < 0) return 'negative';
    return 'neutral';
  };

  return (
    <div className={`stats-card ${alert ? 'alert' : ''}`}>
      <div className="stats-card-header">
        <span className="stats-icon">{icon}</span>
        {trend !== undefined && (
          <span className={`stats-trend ${getTrendClass()}`}>
            {getTrendIcon()} {Math.abs(trend)}%
          </span>
        )}
      </div>
      
      <div className="stats-card-body">
        <h3 className="stats-title">{title}</h3>
        <div className="stats-value">{value}</div>
        {subtitle && <div className="stats-subtitle">{subtitle}</div>}
      </div>

      {alert && (
        <div className="stats-alert">
          ⚠️ Requires attention
        </div>
      )}
    </div>
  );
};

export default StatsCard;